<template>
  <div>
    <div class="head">
      <div class="carousel">
        <div v-if="bannerLoading" class="skeleton-carousel">
          <div class="skeleton-carousel-item"></div>
        </div>
        <el-carousel v-else style="height: 470px">
          <el-carousel-item
            v-for="item in bannerList"
            :key="item.id"
            style="height: 470px"
          >
            <div class="img-box" @click="jumpToDeatil(item.targetId)">
              <el-image
                style="width: 1120px; height: 470px"
                :src="item.bannerUrl"
                fit="cover"
              >
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
              <div class="img-title">
                {{ item.bannerName }}
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
      <!-- <div class="card" style="margin-left: 20px">
        <div class="card-title">
          <div class="flex">
            <span class="chinese">学术动态</span>
            <span class="english">Research News</span>
          </div>
          <div class="more" @click="toMore(1)">更多</div>
        </div>
        <div class="card-list">
          <div
            class="item"
            v-for="(item, index) in list"
            :key="item"
            v-show="index < 5"
          >
            <span><i class="el-icon-d-arrow-right"></i></span>
            <span>
              {{ item.name }}
            </span>
          </div>
        </div>
      </div> -->
    </div>
    <div>
      <div class="middle">
        <div class="card" style="width: 500px;">
          <div class="card-title">
            <div class="flex">
              <span class="chinese">团队简介</span>
              <span class="english">About Us</span>
            </div>
            <!-- <div class="more" @click="toDetail('/research')">更多</div> -->
          </div>
          <div v-if="teamDetailLoading" class="skeleton-container">
            <div class="skeleton-line"></div>
            <div class="skeleton-line"></div>
            <div class="skeleton-line"></div>
            <div class="skeleton-line"></div>
            <div class="skeleton-line"></div>
          </div>
          <div v-else class="ql-editor" v-html="teamDetail.description"></div>
        </div>
        <div class="card" style="margin-left: 20px;width: 500px;">
          <div class="card-title">
            <div class="flex">
              <span class="chinese">通知公告</span>
              <span class="english">Notice</span>
            </div>
            <div class="more" @click="toMore('notice')">更多</div>
          </div>
          <div v-if="noticeListLoading" class="skeleton-container">
            <div class="skeleton-line"></div>
            <div class="skeleton-line"></div>
            <div class="skeleton-line"></div>
            <div class="skeleton-line"></div>
            <div class="skeleton-line"></div>
          </div>
          <div v-else class="card-list">
            <div
              class="item"
              v-for="(item, index) in noticeList"
              :key="item.id"
              v-show="index < 5"
              @click="routerTo(`/detail?id=${item.id}`, item)"
            >
              <div class="timeLine">
                <div class="title">
                  <span><i class="el-icon-d-arrow-right"></i></span>
                  <span>{{ item.title }}</span>
                </div>
                <div class="time">
                  {{ item.createdTime | formatDate("YYYY-MM-DD") }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="middle">
      <div class="card" >
        <div class="card-title">
          <div class="flex">
            <span class="chinese">学术动态</span>
            <span class="english">Trends</span>
          </div>
          <!-- <div class="more" @click="routerTo('/detail', item)">更多</div> -->
        </div>
        <div v-if="academicTrendLoading" class="skeleton-container">
            <div class="skeleton-line"></div>
            <div class="skeleton-line"></div>
            <div class="skeleton-line"></div>
            <div class="skeleton-line"></div>
            <div class="skeleton-line"></div>
          </div>
        <div v-else class="card-list">
          <div
            class="item"
            v-for="(item, index) in academicTrendList"
            :key="item.id"
            v-show="index < 5"
            @click="routerTo('/detail', item)"
          >
            <div style="width: 1100px;">
              <span><i class="el-icon-d-arrow-right"></i></span>
              <span>
                {{ item.title }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="middle">
      <div class="card" >
        <div class="card-title">
          <div class="flex">
            <span class="chinese">发表论文</span>
            <span class="english">Publications</span>
          </div>
          <div class="more" @click="routerTo('/publications')">更多</div>
        </div>
        <div v-if="publicationLoading" class="skeleton-container">
            <div class="skeleton-line"></div>
            <div class="skeleton-line"></div>
            <div class="skeleton-line"></div>
            <div class="skeleton-line"></div>
            <div class="skeleton-line"></div>
          </div>
        <div v-else class="card-list">
          <div
            class="item"
            v-for="(item, index) in publicationList"
            :key="item.id"
            v-show="index < 5"
            @click="routerTo(`/publications`)"
          >
            <div style="width: 1100px;">
              <span><i class="el-icon-d-arrow-right"></i></span>
              <span>
                {{ item.title }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom">
      <div class="card" >
        <div class="card-title center">
          <div class="flex">
            <span class="chinese" @click="routerTo('/groupAlbum')">团队生活</span>
            <span class="english">Group Album</span>
          </div>
        </div>
        <div class="card-image">
          <div v-if="teamLifeLoading" class="skeleton-carousel">
            <div class="skeleton-carousel-item" style="height: 330px"></div>
          </div>
          <el-carousel v-else style="height: 330px" type="card">
            <el-carousel-item
              v-for="item in teamLifeList"
              :key="item.id"
            >
              <el-image
                style="width: 550px; height: 330px"
                :src="item.image"
                fit="cover"
                 @click="routerTo(`/detail`, item)"
              >
              </el-image>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
      <div class="links">
        <div class="title">
          <div class="line"></div>
          <div class="flex" style="padding:0 20px;flex-shrink: 0;">
            <span class="chinese">相关链接</span>
            <span class="english">Related Links</span>
          </div>
          <div class="line"></div>
        </div>
        <div class="el-links">
          <div @click="to('https://www.guet.edu.cn/gra/')">桂电研究生院</div>
          <div @click="to('https://www.guet.edu.cn/lib/')">桂电图书馆</div>
          <div @click="to('https://www.guet.edu.cn/yjszs/')">桂电研招网</div>
          <div @click="to('https://www.nrel.gov/pv/cell-efficiency.html')">NREL</div>
          <div @click="to('https://xb.guet.edu.cn/')">桂林电子科技大学学报</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getHomeBannerPage, getTeamDetail, getNoticePage, getTeamLifePage, getPublicationPage, getAcademicTrendPage} from '@/api/api'
import '@/dist/quill.core.css'
import '@/dist/quill.snow.css'
import '@/dist/quill.bubble.css'
export default {
  data () {
    return {
      bannerList: [],
      noticeList: [],
      teamLifeList: [],
      publicationList: [],
      academicTrendList: [],
      teamDetail: {},
      teamDetailLoading: true,
      noticeListLoading: true,
      bannerLoading: true,
      academicTrendLoading: true,
      publicationLoading: true,
      teamLifeLoading: true
    }
  },
  created () {
    // 先从本地存储加载数据
    this.loadFromLocalStorage()
    // 然后请求新数据
    this.getHomeBannerPage()
    this.getNoticePage()
    this.getTeamLifePage()
    this.getPublicationPage()
    this.getTeamDetail()
    this.getAcademicTrendPage()
  },
  methods: {
    to (http) {
      window.location.href = http
    },
    toMore (type) {
      this.$router.push(
        {path: `/list?type=${type}`}
      )
    },
    routerTo (path, row) {
      if (row) {
        sessionStorage.setItem('detail', JSON.stringify(row))
      }
      this.$router.push({
        path
      })
    },
    loadFromLocalStorage () {
      // 从本地存储加载数据
      const bannerList = localStorage.getItem('bannerList')
      const noticeList = localStorage.getItem('noticeList')
      const teamLifeList = localStorage.getItem('teamLifeList')
      const publicationList = localStorage.getItem('publicationList')
      const academicTrendList = localStorage.getItem('academicTrendList')
      const teamDetail = localStorage.getItem('teamDetail')
      if (bannerList) {
        this.bannerList = JSON.parse(bannerList)
        this.bannerLoading = false
      }
      if (noticeList) {
        this.noticeList = JSON.parse(noticeList)
        this.noticeListLoading = false
      }
      if (teamLifeList) {
        this.teamLifeList = JSON.parse(teamLifeList)
        this.teamLifeLoading = false
      }
      if (publicationList) {
        this.publicationList = JSON.parse(publicationList)
        this.publicationLoading = false
      }
      if (academicTrendList) {
        this.academicTrendList = JSON.parse(academicTrendList)
        this.academicTrendLoading = false
      }
      if (teamDetail) {
        this.teamDetail = JSON.parse(teamDetail)
        this.teamDetailLoading = false
      }
    },
    jumpToDeatil (id) {
      this.$router.push({
        path: `/detail?type=query&id=${id}`
      })
    },
    getAcademicTrendPage () {
      let data = {
        pageSize: 5
      }
      getAcademicTrendPage(data).then(res => {
        if (res.code === 200) {
          this.academicTrendList = res.data.list
          localStorage.setItem('academicTrendList', JSON.stringify(res.data.list))
        }
        this.academicTrendLoading = false
      })
    },
    getHomeBannerPage () {
      let data = {
        pageSize: 5
      }
      getHomeBannerPage(data).then(res => {
        if (res.code === 200) {
          this.bannerList = res.data.list
          localStorage.setItem('bannerList', JSON.stringify(res.data.list))
        }
        this.bannerLoading = false
      })
    },
    getNoticePage () {
      let data = {
        pageSize: 5
      }
      getNoticePage(data).then(res => {
        if (res.code === 200) {
          this.noticeList = res.data.list
          localStorage.setItem('noticeList', JSON.stringify(res.data.list))
        }
        this.noticeListLoading = false
      })
    },
    getPublicationPage () {
      let data = {
        pageSize: 5
      }
      getPublicationPage(data).then(res => {
        if (res.code === 200) {
          this.publicationList = res.data.list
          localStorage.setItem('publicationList', JSON.stringify(res.data.list))
        }
        this.publicationLoading = false
      })
    },
    getTeamLifePage () {
      let data = {
        pageSize: 5
      }
      getTeamLifePage(data).then(res => {
        if (res.code === 200) {
          this.teamLifeList = res.data.list
          localStorage.setItem('teamLifeList', JSON.stringify(res.data.list))
        }
        this.teamLifeLoading = false
      })
    },
    getTeamDetail () {
      getTeamDetail().then(res => {
        if (res.code === 200) {
          this.teamDetail = res.data
          localStorage.setItem('teamDetail', JSON.stringify(res.data))
        }
        this.teamDetailLoading = false
      })
    }
  }
}
</script>

<style scoped>
.head {
  /* background: #fff; */
  display: flex;
  /* margin-top: 20px; */
}

.carousel {
  height: 470px;
  width: 1120px;
  flex-shrink: 0;
}

.image-slot {
  width: 1120px;
  height: 470px;
  font-size: 40px;
}

.img-box {
  position: relative;
  background: #fff;
}

.img-title {
  background: linear-gradient(to top, #1A3D3D, #1A3D3D00);
  position: absolute;
  z-index: 999;
  color: black;
  bottom: 0;
  width: 100%;
  height: 100px;
  font-size: 22px;
  font-weight: 600;
  color: #fff;
  line-height: 130px;
  padding: 0 20px;
  white-space: nowrap; /* 防止文本换行 */
  overflow: hidden; /* 隐藏溢出的内容 */
  text-overflow: ellipsis; /* 显示省略符号来代表被修剪的文本 */
}

.card {
  flex-grow: 1;
}

.card-title {
  height: 40px;
  letter-spacing: 1px;
  font-size: 22px;
  color: #1A3D3D;
  display: flex;
  justify-content: space-between;
  border-bottom: 3px solid #1A3D3D;
  font-weight: bold;
}

.english {
  font-size: 16px;
}

.card .more {
  font-size: 14px;
  line-height: 30px;
  transition: 1s;
}

.card-list {
  height: 327px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding-top: 20px;
  /* color: #2e5cd2; */
  color: #1A3D3D;
  font-size: 15px;
  font-weight: bold;
  box-sizing: border-box;
}

.card .item {
  flex-grow: 1;
  border-bottom: 1px solid #ccc;
}

.card .item + .item {
  margin-top: 10px;
}

.card .item:hover span {
  cursor: pointer;
  color: #D4AF37;
}

.card .item span {
  color: #243257;
  transition: 0.3s;
}

.middle {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}

.middle .card-list {
  height: auto;
  padding-top: 0;
}

.middle .card .item {
  padding: 10px 0;
  display: flex;
}

.middle .card .item + .item {
  margin-top: 0px;
}

.middle .card .item span {
  color: #333;
  font-size: 14px;
}

.middle .card .item:hover span {
  cursor: pointer;
  color: #D4AF37;
}

.middle .card .item div {
  white-space: nowrap; /* 防止文本换行 */
  overflow: hidden; /* 隐藏溢出的内容 */
  text-overflow: ellipsis; /* 显示省略符号来代表被修剪的文本 */
  /* width: 500px; */
}

.bottom {
  margin-top: 40px;
}

.bottom .center {
  text-align: center;
  justify-content: center;
}

.card-image {
  margin-top: 20px;
}

.links {
  margin-top: 40px;
}

.links .title {
  height: 40px;
  letter-spacing: 1px;
  font-size: 22px;
  font-weight: bold;
  color: #2f4f4f;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.line {
  height: 3px;
  flex-grow: 1;
  background: #2f4f4f;
}

.el-links {
  font-size: 16px;
  display: flex;
  flex-wrap: wrap;
  padding: 0 80px;
  box-sizing: border-box;
  color: #2f4f4f;
}

.el-links div {
  padding: 10px 20px;
  text-align: center;
}

.el-links div:hover {
  cursor: pointer;
}

.more:hover {
  cursor: pointer;
  color: #D4AF37
}

.timeLine {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.timeLine .title {
  flex-grow: 1;
}

.time {
  color: #888;
  text-align: right;
  width: 100px;
  flex-shrink: 0;
}

/* 骨架屏样式 */
.skeleton-container {
  padding: 20px 0;
}

.skeleton-line {
  height: 16px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: skeleton-loading 1.5s ease-in-out infinite;
  margin-bottom: 12px;
  border-radius: 4px;
}

.skeleton-line:nth-child(1) {
  width: 80%;
}

.skeleton-line:nth-child(2) {
  width: 90%;
}

.skeleton-line:nth-child(3) {
  width: 85%;
}

.skeleton-line:nth-child(4) {
  width: 95%;
}

.skeleton-line:nth-child(5) {
  width: 75%;
}

@keyframes skeleton-loading {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

/* 轮播图骨架屏样式 */
.skeleton-carousel {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.skeleton-carousel-item {
  width: 1120px;
  height: 470px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: skeleton-loading 1.5s ease-in-out infinite;
  border-radius: 4px;
}
</style>



// WEBPACK FOOTER //
// src/view/home.vue